import React, { useCallback, useState } from "react";

const WallComment = ({
  comment,
  handleDeleteCommentBtn,
  handleReportCommentBtn,
  handleShowLikeUsersButton,
  currentUser,
}) => {
  const [likeUserIds, setLikeUserIds] = useState(
    comment && comment.walls_comments_like_users
      ? comment.walls_comments_like_users.map((like_user) => like_user.user_id)
      : []
  );

  const handleLikeButton = useCallback(() => {
    const formData = new FormData();
    formData.append("walls_comment_id", comment.id);
    $.ajax({
      url: "/api/walls/like_comment",
      type: "POST",
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(() => {
        setLikeUserIds((v) => [...v, currentUser.id]);
      })
      .fail(function() {});
  }, []);

  return (
    <div className="container mt-3" key={comment.id}>
      <div className="row justify-content-around align-items-start pb-3">
        <div className="col-1 col-md-1 pl-2 mr-3 mt-3">
          <img
            src={comment.company
                ? (comment.companies_user ? comment.companies_user.avatar_thumb : '' ) 
                : (comment.user ? comment.user.avatar_thumb : '')}
            className="event-member-icon"
          />
        </div>
        <div className="col">
          <div className="d-flex justify-content-between pl-1 mb-1" style={{ width: '94%' }}>
            <p className="text-fz-11px text-fw-bold text-fz-green mb-0">
              {comment.company ? (
                <a
                  href={
                    comment.companies_user ? "/community/" + comment.company.id_to_param + "/member/" + comment.companies_user.member_id : ""
                  }
                  style={{ textDecoration: 'none' }}
                >
                  @{comment.companies_user
                    ? comment.company.is_real_name_required 
                    ? comment.companies_user.view_full_name_disp : 
                      comment.companies_user.nickname
                  : "退会ユーザー"}
                </a>
              ) : (
                <a
                  href={comment.user ? "/member/profile/" + comment.user.tunagate_id : ''}
                  style={{ textDecoration: "none" }}
                >
                  @{comment.user ? comment.user.tunagate_id : "退会ユーザー"}
                </a>
              )
              }
            </p>
            <div className="d-flex">
              <p className="text-fz-xs text-black-20 mb-0">
                {comment.created_at_time_ago_format}
              </p>
              <div className="dropdown dropleft">
                <img
                  style={{ padding: '0 2px 0 12px' }}
                  id="dropdownMenu"
                  height={15}
                  className="position-absolute"
                  data-toggle="dropdown"
                  src="/assets2019/img/icon_reader.svg"
                  alt=""
                />
                <div className="dropdown-menu" aria-labelledby="dropdownMenu">
                  {currentUser && currentUser.id == comment.user_id ? (
                    <button
                      onClick={() => handleDeleteCommentBtn(comment.id)}
                      className="dropdown-item btn btn-light text-danger text-center"
                      type="button"
                    >
                      削除する
                    </button>
                  ) : (
                    <button
                      onClick={() => handleReportCommentBtn(comment.id)}
                      className="dropdown-item btn btn-light text-primary text-center"
                      type="button"
                    >
                      通報する
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <p
            className="text-fz-11px card border-0 bg-white mb-0 p-3"
            dangerouslySetInnerHTML={{ __html: comment.comment_display }}
          />
          {/* <div className="d-flex">
            {!currentUser ? (
              ""
            ) : !likeUserIds.includes(currentUser.id) ? (
              <span
                onClick={() => handleLikeButton(comment.id)}
                className="text-black-20 ml-2"
              >
                ♡
              </span>
            ) : (
              <p className="text-fz-xs text-black-20 mt-1 mb-0 ml-2">
                いいね済
              </p>
            )}
            {likeUserIds.length > 0 ? (
              <span
                onClick={() => handleShowLikeUsersButton(comment.id)}
                className="text-fz-xs text-black-20 mt-1 mb-0 ml-2"
              >
                {likeUserIds.length}件のいいね
              </span>
            ) : (
              ""
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default WallComment;
